import { render, staticRenderFns } from "./DispatchBags.vue?vue&type=template&id=189e0925"
import script from "./DispatchBags.vue?vue&type=script&lang=js"
export * from "./DispatchBags.vue?vue&type=script&lang=js"
import style0 from "./DispatchBags.vue?vue&type=style&index=0&id=189e0925&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports